import { useTranslation } from 'react-i18next';
import Modal from 'src/components/ui/Features/Modal/Modal';
import { IFrame } from 'src/components/ui/GlobalComponents/IFrame/IFrame';
import { IconLocation, ImageLocation } from 'src/utils/URLUtils';
import { Feature } from '../../Feature';
import styles from './VideoModal.module.scss';

interface VideoModalProps {
    isModalOpen: boolean;
    setIsModalOpen: (value: boolean) => void;
    feature: Feature;
}

const VideoModal = ({ isModalOpen, setIsModalOpen, feature }: VideoModalProps) => {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
        >
            <div className={styles.videoModal}>
                <div className={styles.header}>
                    <h2>{t('Get WordUp Pro')}</h2>
                    <img src={IconLocation('x')} className={styles.close}
                        alt={t('close')} onClick={() => setIsModalOpen(false)} />
                </div>
                <img className={styles.logo} src={ImageLocation(feature.icon)}
                    alt={t(feature.title)} />
                <h1>{t(feature.title)}</h1>
                <p>{t(feature.description)}</p>
                {/* 
                <div className={styles.iFrameContainer}> */}
                <IFrame src={feature.videoUrl ?? ''} />
                {/* </div> */}
                <button onClick={() => setIsModalOpen(false)}
                    className={styles.closeButton}>{t('Close')}</button>
            </div>
        </Modal>
    );
};

export default VideoModal;